{
  "login": {
    "title": "Ingresar",
    "subtitle": "Entra a Fermin Admin con tu correo y contraseña.",
    "email": "Correo",
    "password": "Contraseña",
    "submit": "Ingresar",
    "forgot": "Olvidé mi contraseña",
    "invalid": "Correo o contraseña incorrectos",
    "locked": "Demasiados intentos. Vuelve a intentarlo en {seconds}.",
    "lockedHint": "Por seguridad, el acceso queda bloqueado unos minutos tras varios intentos fallidos."
  },
  "forgot": {
    "title": "Olvidé mi contraseña",
    "description": "Te enviamos un enlace para crear una nueva contraseña.",
    "email": "Correo",
    "submit": "Enviar enlace",
    "sent": "Si el correo existe, te enviamos un enlace válido por 30 minutos.",
    "tooMany": "Ya solicitaste varios enlaces. Espera una hora antes de pedir otro.",
    "back": "Volver a ingresar"
  },
  "password": {
    "titleSetup": "Configurar contraseña",
    "titleReset": "Restablecer contraseña",
    "new": "Nueva contraseña",
    "confirm": "Repite la contraseña",
    "hint": "Usa entre 10 y 128 caracteres.",
    "mismatch": "Las contraseñas no coinciden.",
    "submit": "Guardar contraseña",
    "expired": "Este enlace venció. Pide uno nuevo a tu administrador.",
    "invalid": "Este enlace ya no es válido. Pide uno nuevo a tu administrador.",
    "forAccount": "Para la cuenta {email}",
    "subtitleSetup": "Define la contraseña con la que entrarás a Fermin Admin.",
    "subtitleReset": "Elige una contraseña nueva para tu cuenta.",
    "strengthLabel": "Longitud de la contraseña",
    "strengthShort": "Faltan {count} caracteres",
    "strengthOk": "Longitud suficiente",
    "strengthLong": "Máximo 128 caracteres",
    "show": "Mostrar contraseña",
    "hide": "Ocultar contraseña",
    "expiresAt": "El enlace vence el {date}",
    "checking": "Verificando el enlace…",
    "linkProblemTitle": "El enlace ya no sirve",
    "goToLogin": "Ir a ingresar",
    "successTitle": "Contraseña guardada",
    "successDescription": "Ya puedes usar Fermin Admin.",
    "submitReset": "Restablecer contraseña"
  },
  "session": {
    "current": "Esta sesión",
    "close": "Cerrar",
    "closeAll": "Cerrar las demás sesiones"
  },
  "stub": {
    "underConstruction": "Pantalla en construcción (US1/US2)"
  }
}
